/* Owner round 4: the logo is one compact drop zone, the references a grid of small thumbnails. */
.logo,
.references,
.draft {
  display: flex;
  flex-direction: column;
  gap: var(--space-2);
  min-inline-size: 0;
}

/* The mockup's `.drop`: dashed, centred, the picker as a link; about 100px tall. */
.drop {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  min-block-size: 100px;
  padding: var(--space-3);
  border: 1px dashed var(--border-control);
  border-radius: var(--radius-card);
  color: var(--text-muted);
  font-size: var(--font-size-13);
  text-align: center;
}

/* Mockup v3 P5: the zone highlights while a file is dragged over it (the mockup's `.drop.is-over`). */
.drop[data-over="true"] {
  border-style: solid;
  border-color: var(--action-surface);
  background: var(--action-soft);
  color: var(--text);
}

.logoImage {
  max-inline-size: 100%;
  max-block-size: 48px;
  object-fit: contain;
}

/* The file input is visually hidden, still focusable: the label next to it is what is drawn (see .srOnly). */

.pick {
  color: var(--action-text);
  font-weight: var(--font-weight-medium);
  text-decoration: underline;
  text-underline-offset: 2px;
  cursor: pointer;
}

.fileInput:focus-visible + .pick,
.fileInput:focus-visible + .tileLabel {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
  border-radius: 2px;
}

.fileInput:disabled + .pick,
.fileInput:disabled + .tileLabel {
  cursor: not-allowed;
}

.help,
.fileName {
  margin: 0;
  color: var(--text-subtle);
  font-size: var(--font-size-12);
}

.fileName {
  color: var(--text-muted);
  overflow-wrap: anywhere;
}

/* Four 64px tiles in a row; a chosen file's alt text and upload take the full row under them. */
.tiles {
  display: grid;
  grid-template-columns: repeat(4, 64px);
  gap: var(--space-2);
  margin: 0;
  padding: 0;
  list-style: none;
}

.slot {
  display: contents;
}

.tile {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  inline-size: 64px;
  block-size: 64px;
  overflow: hidden;
  border: 1px dashed var(--border-control);
  border-radius: var(--radius-control);
  color: var(--text-muted);
}

.tile[data-filled="true"] {
  border-style: solid;
  border-color: var(--border);
}

.thumb {
  inline-size: 100%;
  block-size: 100%;
  object-fit: cover;
}

/* The whole tile is the picker's label; its text is for assistive technology only. */
.tileLabel {
  position: absolute;
  inset: 0;
  cursor: pointer;
}

.srOnly,
.fileInput {
  position: absolute;
  inline-size: 1px;
  block-size: 1px;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
}

.tile:hover {
  border-color: var(--border-control);
  background: var(--state-hover);
}

.slotDraft {
  grid-column: 1 / -1;
}

.slotDraft:empty {
  display: none;
}

.status {
  margin: 0;
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}

.refusal {
  margin: 0;
  color: var(--danger-text);
  font-size: var(--font-size-13);
  font-weight: var(--font-weight-semibold);
}
